import React, { useEffect } from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel';
import { useTranslation } from 'react-i18next';

const features = [
  { key: 'guidance', image: '/02_guidance.jpg' },
  { key: 'trigger', image: '/03_trigger.jpg' },
  { key: 'guna', image: '/04_guna.jpg' },
  { key: 'programs', image: '/05_programs.jpg' },
  { key: 'library', image: '/09_chapters.jpg' },
  { key: 'kosha', image: '/07_kosha.jpg' },
  { key: 'reflection', image: '/08_reflection.jpg' },
  { key: 'wellness', image: '/10_wellness.jpg' },
  { key: 'dosha', image: '/11_dosha.jpg' },
  { key: 'lifestyle', image: '/12_lifestyle.jpg' }
];

export default function FeatureCarousel() {
  const { t } = useTranslation();
  const [api, setApi] = React.useState();

  useEffect(() => {
    if (!api) return;

    // Auto-scroll every 3 seconds
    const interval = setInterval(() => {
      api.scrollNext();
    }, 3000);

    return () => clearInterval(interval);
  }, [api]);

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-gradient-to-b from-background to-muted/20">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm uppercase tracking-[0.2em] text-primary/70 mb-3 font-medium">
            {t('landing.carousel.label')}
          </p>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-foreground mb-4">
            {t('landing.carousel.title')}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-base md:text-lg">
            {t('landing.carousel.subtitle')}
          </p>
        </div>

        <Carousel 
          className="w-full" 
          opts={{ loop: true }}
          setApi={setApi}
        >
          <CarouselContent>
            {features.map((feature, index) => (
              <CarouselItem key={index}>
                <div className="p-2">
                  <div className="bg-card rounded-lg overflow-hidden shadow-lg border border-border/50">
                    <div className="relative aspect-[4/3] bg-muted">
                      <img
                        src={feature.image}
                        alt={t(`landing.carousel.features.${feature.key}.title`)}
                        className="w-full h-full object-cover"
                        loading={index < 3 ? 'eager' : 'lazy'}
                      />
                    </div>
                    <div className="p-6 md:p-8 text-center">
                      <h3 className="font-['Playfair_Display'] text-xl md:text-2xl font-semibold text-foreground mb-2">
                        {t(`landing.carousel.features.${feature.key}.title`)}
                      </h3>
                      <p className="text-muted-foreground text-sm md:text-base">
                        {t(`landing.carousel.features.${feature.key}.description`)}
                      </p>
                    </div>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="left-2 md:-left-12" />
          <CarouselNext className="right-2 md:-right-12" />
        </Carousel>
      </div>
    </section>
  );
}
